import { type HttpClient } from '../useHttpClient';

export interface UnitInsightChatResponse {
  data: {
    id: number;
    contents: {
      version: 1;
      role: 'user' | 'assistant';
      parts: UnitInsightLlmChatsResponsePart[];
    };
    createdOn: string | null;
  }[];
}

export type UnitInsightLlmChatsResponsePart =
  | UnitInsightLlmChatsResponseTextPart
  | UnitInsightLlmChatsResponseFilePart;

export interface UnitInsightLlmChatsResponseTextPart {
  text: string;
}

export interface UnitInsightLlmChatsResponseFilePart {
  fileData: {
    fileUri: string;
    mimeType: string;
  };
}

export const getUnitInsightLlmChat =
  (httpClient: HttpClient) =>
  async ({
    unitId,
    insightId,
    chatId,
  }: {
    unitId: string | number;
    insightId: string | number;
    chatId: string | number;
  }) => {
    const res = await httpClient.api(
      `/kpis/unit/${unitId}/insights/llm/${insightId}/chats/${chatId}`
    );

    return res.json as UnitInsightChatResponse;
  };
